import { render } from "./Administrative.vue?vue&type=template&id=f12a80be&scoped=true"
import script from "./Administrative.vue?vue&type=script&lang=js"
export * from "./Administrative.vue?vue&type=script&lang=js"

import "./Administrative.vue?vue&type=style&index=0&id=f12a80be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f12a80be"],['__file',"src/components/h5/data/Administrative.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f12a80be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f12a80be', __exports__)) {
    api.reload('f12a80be', __exports__)
  }
  
  module.hot.accept("./Administrative.vue?vue&type=template&id=f12a80be&scoped=true", () => {
    api.rerender('f12a80be', render)
  })

}


export default __exports__